/**
 * Yo Dawg, I heard you like strings
 * @return Returns a string with the first character uppercase
 */

export const titleCase = (string: string): string => {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
};
